module.exports = __webpack_public_path__ + "img/10.b49c12b1.jpg";